import { memo } from 'react';

import { getWebBoosterVairant } from '../../../constants/webBoosterType';
import useLocale from '../../../hooks/useLocale';
import { Space } from '../../../models/SpaceStore/Space';
import { WebBoosterType } from '../../../models/UserStore';
import { JoyajoyImage } from '../JoyajoyImage';
import { SvgIcon } from '../SVGIcon';

import styles from './SpaceNode.module.css';

export type SpaceNodeProps = {
  space: Space;
  webBoosterType: WebBoosterType | undefined;
  isHideName?: boolean;
  onClickClub: () => void;
};

export const SpaceNode = memo((props: SpaceNodeProps) => {
  const { space, webBoosterType, isHideName, onClickClub } = props;
  const l = useLocale();

  const spaceInfo = l(space.i18nClassroomInfo);

  const spaceIconSource = space?.icon?.publicUrls?.small ?? '';

  return (
    <div className={styles.space_node}>
      <div className={styles.centered_container} onClick={onClickClub}>
        <div className={styles.space_icon_container}>
          <JoyajoyImage
            resource={{ uri: spaceIconSource }}
            className={styles.space_icon}
          />
          {space.isHome ? (
            <div className={styles.boosterContainer}>
              <SvgIcon
                name={getWebBoosterVairant(webBoosterType).icon}
                className={styles.boosterIcon}
              />
            </div>
          ) : null}
        </div>
        {!isHideName && (
          <div className={styles.text_component}>
            <p className={styles.space_name}>{spaceInfo?.name}</p>
          </div>
        )}
      </div>
    </div>
  );
});
